import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '水成环保科技股份有限公司_官网首页'
          }
        }, {
          path: '/about/:type',
          name: 'about',
          component: resolve => require(['@/view/About'], resolve),
          meta: {
            title: '水成环保科技股份有限公司_走进水成'
          }
        }, {
          path: '/product/:type',
          name: 'product',
          component: resolve => require(['@/view/Product'], resolve),
          meta: {
            title: '水成环保科技股份有限公司_产品中心'
          }
        }, {
          path: '/news',
          name: 'news',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '水成环保科技股份有限公司_品牌新闻'
          }
        }, {
          path: '/water',
          name: 'water',
          component: resolve => require(['@/view/Water'], resolve),
          meta: {
            title: '水成环保科技股份有限公司_水之道'
          }
        }, {
          path: '/join/:type',
          name: 'join',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '水成环保科技股份有限公司_加入我们'
          }
        }, {
          path: '/content/:id',
          name: 'content',
          component: resolve => require(['@/view/Content'], resolve),
          meta: {
            title: '水成环保科技股份有限公司_新闻详情'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js